import * as yup from 'yup'

const SchemaValidations = (totalCost) => {
  return  yup.object().shape({
    dteType: yup.mixed().required('El tipo de documento a emitir es obligatorio'),
    receiverName: yup.string().required('El nombre de cliente o empresa es obligatorio'),
    //tradeName: yup.string().required('El nombre comercial es obligatorio'),
    tradeName: yup.string().when('dteType.value', {
      is: value => value !== '01',
      then: yup.string().required("El nombre comercial es obligatorio"),
      otherwise: yup.string().nullable()
    }),
    economicActivity: yup.mixed().when('dteType.value', {
      is: value => value !== '01' && value !== '14',
      then: yup.mixed().required("La actividad económica es obligatoria"),
      otherwise: yup.mixed().nullable()
    }),
    nit: yup.string().when('dteType.value', {
      is: value => (value !== '01' && value !== '08'),
      then: yup.string().required("El NIT es obligatorio"),
      otherwise: yup.string().nullable()
    }),
    nrc: yup.string().when('dteType.value', {
      is: value => value !== '01' && value !== '11' && value !== '08' && value !== '14',
      then: yup.string().required("El NRC es obligatorio"),
      otherwise: yup.string().nullable()
    }),
    dui: yup.string().when('dteType.value', {
      is: value => value === '01',
      then: yup.string().required("El DUI es obligatorio"),
      otherwise: yup.string().nullable()
    }),
    country: yup.mixed().when('dteType.value', {
      is: value => value === '11' || value === '14',
      then: yup.mixed().required("El país es obligatorio"),
      otherwise: yup.mixed().nullable()
    }),
    department: yup.mixed().when('dteType.value', {
      is: value => value === '01' || value === '03',
      then: yup.mixed().required("El departamento es obligatorio"),
      otherwise: yup.mixed().nullable()
    }),
    municipality: yup.mixed().when('dteType.value', {
      is: value => value === '01' || value === '03',
      then: yup.mixed().required("El municipio es obligatorio"),
      otherwise: yup.mixed().nullable()
    }),
    district: yup.mixed().when('dteType.value', {
      is: value => value === '01' || value === '03',
      then: yup.mixed().required("El distrito es obligatorio"),
      otherwise: yup.mixed().nullable()
    }),
    largeConsumer: yup.mixed().when('dteType.value', {
      is: value => value === '03',
      then: yup.mixed().required("El tipo de contribuyente es obligatorio"),
      otherwise: yup.mixed().nullable()
    }),
    address: yup.string().when('dteType.value', {
      is: value => value === '01' || value === '03',
      then: yup.string().required("La dirección es obligatoria"),
      otherwise: yup.string().nullable()
    }),
  
    receiverPhoneNumber: yup.string().when('dteType.value', {
      is: value => value === '01' || value === '03' || value === '11',
      then: yup
        .string()
        .matches(
          /^\+[0-9]{8,15}$/,
          'El número de teléfono debe ser válido y debe incluir el prefijo internacional con "+"'
        )
        .required('El número de teléfono es obligatorio'),
      otherwise: yup.string().nullable()
    }),
    //receiverEmail: totalCost > 25000 ? yup.string().email('No es un correo válido').required('El correo electrónico es obligatorio') : yup.string(),
    dteClientType: yup.mixed().required('El Tipo de documento del cliente es obligatorio')
  })
} 

// Esquema de validación para productos
const ProductSchema = yup.object().shape({
  productCode: yup
  .string()
  .required('El código del producto es obligatorio')
  .min(3, 'El código debe tener al menos 3 caracteres'),
  prodType: yup.mixed().required('El tipo de producto es obligatorio'),
  productName: yup.string().required('El nombre de producto es obligatorio'),
  quantity: yup.number().required('La cantidad del producto es obligatoria').positive('La cantidad debe ser un número positivo'),
  unitOfMeasure: yup.mixed().required('La unidad de medida es obligatoria'),
  TypeOfSale: yup.mixed().required('El Tipo de venta es obligatorio'),
  price: yup
  .number()
  .required('El precio del producto es obligatorio')
  .transform((value, originalValue) => (originalValue === "" ? undefined : value))
  .positive('El precio debe ser un número positivo'),
  discount: yup.number()
    .transform((value) => (isNaN(value) || value === null || value === '' ? 0 : value))
    .typeError('El valor debe ser un número')
    .min(0, 'El valor debe ser mayor o igual a 0')
    .max(100, 'El valor debe ser menor o igual a 100')
    .default(0)

});

// Esquema de validación para observaciones
const ObservationSchema = yup.object().shape({
  conditionOperations: yup.string().nullable(),//.required('La condición de operaciones es obligatoria').max(500, 'La observación no puede exceder los 500 caracteres'),
  typePayment: yup.string().nullable(),//.required('La forma de pago es obligatoria'),
  amount: yup.string().nullable(),//.required('El monto es obligatorio')
  operationCondition: yup.mixed().nullable(),
  periodo: yup.string().when('operationCondition', {
    is: (value) => Number(value?.value) === 2,
    then: yup
      .string()
      .required('El periodo es obligatorio')
      .matches(/^[0-9]+$/, 'El periodo debe ser un número'),
    otherwise: yup.string().nullable(),
  }),
  plazo: yup.mixed().when('operationCondition', {
    is: (value) => Number(value?.value) === 2,
    then: yup.mixed().required('El plazo es obligatorio'),
    otherwise: yup.mixed().nullable(),
  }),
});

export  { SchemaValidations, ProductSchema, ObservationSchema }